import { React, PropTypes, UI, TextField, useIntl, useSelector, isSubmittingSelector, Utils } from '../../dependencies';

const { InputWrapper } = UI;

const VatNumberField = ({ formId, rules, ...rest }) => {
    const intl = useIntl();
    const submitting = useSelector(isSubmittingSelector(formId));

    return (
        <InputWrapper style={rules.inputSmall}>
            <TextField
                name="vatNumber"
                placeholder={intl.formatMessage({
                    id: `supplier.form.vatNumber.placeholder`,
                })}
                parse={Utils.toUpperCase}
                disabled={submitting}
                {...rest}
            />
        </InputWrapper>
    );
};

VatNumberField.propTypes = {
    formId: PropTypes.string.isRequired,
    tabIndex: PropTypes.number.isRequired,
};

export default React.memo(VatNumberField);
